import React, { useEffect, useRef, useState } from "react";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import {
    deleteCustomValue,
    getAllCustomValues,
    updateCustomValue
} from "../../apis/AdminApis";

import {
    Divider,
    Form,
    Select,
    Spin
} from "antd";
import UpdateCustomValueDialog from "./dialog/UpdateCustomValueDialog";
import { getAllCompanies } from "../../apis/CompanyApis";


const CustomValue = () => {
    const [apiLoading, setApiLoading] = useState(false);
    const toast = useRef(null);
    const [customValues, setCustomValues] = useState([]);
    const [customValue, setCustomValue] = useState(null);
    const [dialogMode, setDialogMode] = useState("Create");
    const [visibleUpdateCustomValueDialog, setVisibleUpdateCustomValueDialog] = useState(false);
    const [companies, setCompanies] = useState([]);
    const [companyId, setCompanyId] = useState(null);
    const [form] = Form.useForm();

    useEffect(() => {
        fetchCustomValues();
    }, [])

    useEffect(() => {
        fetchCompanies();
    }, [])

    const submit = () => {
        form.validateFields().then((values) => {
            setCompanyId(values.companyId);
        });
    };


    const fetchCompanies = () => {
        setApiLoading(true);
        getAllCompanies()
            .then((res) => {
                if (res.status === 200) {
                    let options = (res.data).map((r) => (
                        { value: r.id, label: r.name }
                    ));

                    options.unshift({ value: null, label: "Global config" });
                    setCompanies(options);
                    setApiLoading(false);
                } else {
                    toast.current.show({
                        severity: "error",
                        summary: "Status",
                        detail: res.response.data,
                        life: 3000,
                    });
                    setApiLoading(false);
                }
            })
            .catch((e) => {
                toast.current.show({
                    severity: "error",
                    summary: "Status",
                    detail: e,
                    life: 3000,
                });
                setApiLoading(false);
            });
    }

    const fetchCustomValues = () => {
        setApiLoading(true);
        getAllCustomValues()
            .then((res) => {
                if (res.status === 200) {
                    setCustomValues(res.data);
                    setApiLoading(false);
                } else {
                    toast.current.show({
                        severity: "error",
                        summary: "Status",
                        detail: res.response.data,
                        life: 3000,
                    });
                    setApiLoading(false);
                }
            })
            .catch((e) => {
                toast.current.show({
                    severity: "error",
                    summary: "Status",
                    detail: e,
                    life: 3000,
                });
                setApiLoading(false);
            });
    }

    const handleDeleteCustomValue = (id) => {
        setApiLoading(true);
        deleteCustomValue(id)
            .then((res) => {
                if (res.status === 200) {
                    fetchCustomValues();
                    setApiLoading(false);
                    toast.current.show({
                        severity: "success",
                        summary: "Status",
                        detail: "Delete Global Config successfully",
                        life: 3000,
                    });
                } else {
                    toast.current.show({
                        severity: "error",
                        summary: "Status",
                        detail: res.response.data,
                        life: 3000,
                    });
                    setApiLoading(false);
                }
            })
            .catch((e) => {
                toast.current.show({
                    severity: "error",
                    summary: "Status",
                    detail: e,
                    life: 3000,
                });
                setApiLoading(false);
            });
    }

    const changeVisibleCustomValueDialog = (visible) => {
        setVisibleUpdateCustomValueDialog(visible);
        fetchCustomValues();
        setCustomValue(null);
    }
    return (
        <React.Fragment>
            <div>
                <Toast ref={toast} />
                <div className="card" style={{ height: "72vh" }}>
                    <div className="grid" style={{ height: "70vh" }}>
                        <div className="col-3 flex align-items-center justify-content-center">
                            <div>
                                <div>
                                    <Form
                                        form={form}
                                        size="middle"
                                        className="custom-form-design"
                                        onFinish={submit}
                                        labelCol={{ span: 12 }}
                                        wrapperCol={{ span: 17 }}
                                    >
                                        <Form.Item
                                            name="companyId"
                                            label="Customer"
                                        >
                                            <Select
                                                mode={"single"}
                                                placeholder="Select Customer"
                                                style={{ width: 200 }}
                                                options={companies}>
                                            </Select>
                                        </Form.Item>
                                        <Button type="submit" style={{ float: "right" }}>
                                            Submit
                                        </Button>
                                    </Form>
                                </div>
                            </div>
                        </div>
                        <div className="col-9">
                            <Toolbar
                                className="mb-4"
                                left={() => {
                                    return (
                                        <React.Fragment>
                                            <div>
                                                <h3 className="m-0">Global Config</h3>
                                            </div>
                                        </React.Fragment>
                                    );
                                }}
                                right={() => {
                                    return (
                                        <React.Fragment>
                                            <Button
                                                style={{
                                                    backgroundColor: "#037EEA",
                                                    borderColor: "#037EEA",
                                                }}
                                                icon={"pi pi-plus"}
                                                label="Create New Config"
                                                onClick={(event) => {
                                                    setCustomValue(null);
                                                    setDialogMode("Create");
                                                    setVisibleUpdateCustomValueDialog(true);
                                                }}
                                            />
                                        </React.Fragment>
                                    );
                                }}
                            ></Toolbar>
                            <DataTable
                                value={customValues.filter(item => item.companyId == companyId)}
                                dataKey="id"
                                responsiveLayout="scroll"
                                selectionMode="single"
                                className="overflow-y-auto"
                                sortMode="multiple"
                                style={{ maxHeight: "50vh" }}
                            >
                                <Column field="key" header="Key" />
                                <Column field="value" header="Value" />
                                <Column header="Action" body={(record) => {
                                    return (
                                        <React.Fragment>
                                            <div className="flex justify-content-center">
                                                {
                                                    <div>
                                                        <Button
                                                            style={{
                                                                backgroundColor: "#037EEA",
                                                                borderColor: "#037EEA",
                                                            }}
                                                            icon={"pi pi-pencil"}
                                                            onClick={(event) => {
                                                                event.preventDefault();
                                                                setCustomValue(record);
                                                                setVisibleUpdateCustomValueDialog(true);
                                                                setDialogMode("Update")
                                                            }}
                                                        />
                                                        <Button
                                                            style={{
                                                                backgroundColor: "#037EEA",
                                                                borderColor: "#037EEA",
                                                                marginLeft: "10px"
                                                            }}
                                                            icon={"pi pi-trash"}
                                                            onClick={(event) => {
                                                                event.preventDefault();
                                                                handleDeleteCustomValue(record.id);
                                                            }}
                                                        />
                                                    </div>
                                                }
                                            </div>
                                        </React.Fragment>
                                    );
                                }}
                                />
                            </DataTable>
                        </div>
                    </div>
                </div>
            </div>

            <UpdateCustomValueDialog
                customValue={customValue}
                dialogMode={dialogMode}
                visible={visibleUpdateCustomValueDialog}
                setVisible={changeVisibleCustomValueDialog}
                companyId={companyId}
            >
            </UpdateCustomValueDialog>
        </React.Fragment>
    );
};

export default CustomValue;
